"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const Node_1 = require("./types/Node");
const parser_1 = require("./parser");
const parseText = text => {
    const children = [];
    let textBuffer = '';
    const flush = () => {
        if (!textBuffer) {
            return;
        }
        children.push({
            type: Node_1.NodeType.Text,
            text: textBuffer
        });
        textBuffer = '';
    };
    let i = 0;
    const l = text.length;
    while (i < l) {
        const match = parser_1.default(text, i, parseText);
        if (match) {
            flush();
            const [node, position] = match;
            children.push(node);
            i = position;
            continue;
        }
        textBuffer += text.charAt(i);
        i += 1;
    }
    flush();
    return children;
};
exports.parse = (message) => {
    return {
        type: Node_1.NodeType.Root,
        children: parseText(message)
    };
};
exports.default = exports.parse;
__exportStar(require("./types/Node"), exports);
//# sourceMappingURL=index.js.map